import { Box } from "@mui/material";

export function FeedPage() {
  /* eslint-disable react/iframe-missing-sandbox */
  return (
    <Box height="100%" position="relative">
      <iframe
        src="https://social-v0-production.up.railway.app/display"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "100%",
        }}
        title="viewVideo"
      />
    </Box>
  );
  /* eslint-enable react/iframe-missing-sandbox */
}
